// src/pages/newFacility/FacilityInfoSkeleton.tsx

import React from "react";
import { Grid, Skeleton, Typography, Box, Card } from "@mui/material";

const FacilityInfoSkeleton = () => {
  return (
    <Grid container spacing={2} padding={2}>
      <Grid item xs={12}>
        <Skeleton variant="text" width={200} height={30} />
      </Grid>

      <Grid item xs={12}>
        <Skeleton variant="rectangular" height={90} />
      </Grid>

      <Grid item xs={12}>
        <Skeleton variant="text" width={200} height={30} />
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2}>
          {Array.from({ length: 2 }).map((_, idx) => (
            <Grid item xs={12} sm={6} key={idx}>
              <Card>
                <Skeleton variant="rectangular" height={"50vh"} />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* <Grid item xs={12}>
        <Skeleton variant="text" width={200} height={30} />
        <Skeleton variant="rectangular" height={56} />
      </Grid>

      <Grid item xs={12}>
        <Skeleton variant="text" width={200} height={30} />
        <Skeleton variant="rectangular" height={56} />
      </Grid>

      <Grid item xs={12}>
        <Skeleton variant="rectangular" width={150} height={40} />
      </Grid> */}
    </Grid>
  );
};

export default FacilityInfoSkeleton;
